module.exports = __webpack_public_path__ + "img/log.25578ef8.png";